var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"ms-label flex items-center",style:(_vm.getStyle)},'div',_vm.$attrs,false),[(_vm.icon)?_c('ms-icon',{staticClass:"m-r-8",style:(_vm.iconStyle),attrs:{"icon":_vm.icon},on:{"click":function($event){return _vm.$emit('icon-click');}}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }